import React, { lazy, Suspense } from "react";

const LazyLisCustomerCall = lazy(() => import("./LisCustomerCall"));
const LazyListCustomerVisit = lazy(() => import("./ListCustomerVisit"));
const LazyListCustomerService = lazy(() => import("./ListCustomerService"));
const LazyListZabuns = lazy(() => import("./ListZabuns"));
const LazyReListZabuns = lazy(() => import("./ReListZabuns"));
export const ReListZabuns = () => (
  <Suspense fallback="loading...">
    <LazyReListZabuns />
  </Suspense>
);
export const ListZabuns = () => (
  <Suspense fallback="loading...">
    <LazyListZabuns />
  </Suspense>
);
export const ListCustomerService = () => (
  <Suspense fallback="loading...">
    <LazyListCustomerService />
  </Suspense>
);
export const LisCustomerCall = () => (
  <Suspense fallback="loading...">
    <LazyLisCustomerCall />
  </Suspense>
);
export const ListCustomerVisit = () => (
  <Suspense fallback="loading...">
    <LazyListCustomerVisit />
  </Suspense>
);

const LazyReListCustomerDetail = lazy(() => import("./ReListCustomerDetail"));
const LazyPrintListCustomer = lazy(() => import("./PrintListCustomer"));
export const ReListCustomerDetail = () => (
  <Suspense fallback="loading...">
    <LazyReListCustomerDetail />
  </Suspense>
);
export const PrintListCustomer = () => (
  <Suspense fallback="loading...">
    <LazyPrintListCustomer />
  </Suspense>
);
